import styled from 'styled-components';
import { Spacer } from '@lux/tokens';

export const Container = styled.div`
    z-index: 0;
    position: relative;
    overflow: visible;
    // TODO: There is no such color in LUX.
    background-color: #f7f7f7;
`;

export const CampaignContainer = styled.div`
    position: relative;
    margin-bottom: 3%;
    border: none;
    display: grid;
    gap: ${Spacer.XXS};
`;
